import React from 'react';
import intl from 'react-intl-universal';

import { isUserSignedIn, isUserProfileLoaded, UserContext, getUserFirstName, getUserPicture, 
    getLinkForSignIn, getLinkForSignOut } from "../../UserContext";
import {Link} from "react-router-dom";
import {COMMUNITY_URL, HELP_URL} from '../../Constants';

/**
 * Copyright (c) Fing Ltd. All rights reserved.
 *
 * @author Tommaso Latini <tommaso@fing.com>
 */
export default class NavbarUser extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            expanded: false
        }
    }

    renderNotSignedUser(context) {
        return (
            <div className="mb-2 mb-md-0 p-2">
                <a className={`btn btn-xs btn-outline-primary transition-3d-hover mr-1 mb-xs-1 mb-sm-0`}
                    href={getLinkForSignIn(context, window.location.href)}>{intl.get('account_sign_in')}
                </a>
            </div>
        );
    }

    renderSignedUser(context, full) {
        const name = getUserFirstName(context);
        const picture = getUserPicture(context);
        const show = this.state.expanded ? "show" : "";
        return (
            <div className={`dropdown navbar-nav-item ${show}`} onMouseEnter={() => this.setState({ expanded: true })} onMouseLeave={() => this.setState({ expanded: false })}>
                <div id="account_icon" className="nav-link nav-link-toggle" role="button" data-toggle="dropdown"
                    aria-haspopup="true" aria-expanded={this.state.expanded} aria-labelledby="account_dropdown">
                    <span className="position-relative">
                        <span className="small text-dark mr-1">{name}</span>
                        <span className="avatar avatar-xs avatar-circle">
                            <img className="avatar-img" src={picture} alt="Profile" />
                        </span>
                    </span>
                </div>
                <div id="account_dropdown" className={`dropdown-menu dropdown-menu-right ${show}`} aria-labelledby="account_icon">
                    <Link className="dropdown-item" to="/account">{intl.get('generic_account')}</Link>
                    {full && <a className="dropdown-item" href={HELP_URL}>{intl.get('generic_support')}</a>}
                    {full && <a className="dropdown-item" href={COMMUNITY_URL}>{intl.get('footer_community')}</a>}
                    <div className="dropdown-divider"></div>
                    <a className="dropdown-item" href={getLinkForSignOut(context, window.location.href)}>{intl.get('account_sign_out')}</a>
                </div>
            </div>
        );
    }

    render() {
        const { full } = this.props;
        return (
            <div className="d-block d-md-flex ml-1 ml-md-0 mt-2 mt-md-0 column-divider-md pl-2">
                <UserContext.Consumer>
                    {userContext => {
                        if (isUserSignedIn(userContext)) {
                            return this.renderSignedUser(userContext, full);
                        } else if (isUserProfileLoaded(userContext)) {
                            return this.renderNotSignedUser(userContext);
                        }
                    }}
                </UserContext.Consumer>
            </div>
        );

    }
};